import { Component } from '@angular/core';
import { SharedService } from '../../../../services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FirestoreService } from '../../../../services/firestore/firestore.service';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { Testimonial } from '../../../../models/testimonials';

@Component({
  selector: 'app-testimonial',
  imports: [CommonModule, FormsModule],
  templateUrl: './testimonial.component.html',
  styleUrl: './testimonial.component.css'
})
export class TestimonialComponent {
  testimonials: Testimonial[] = [];
  currentTestimonial: Testimonial = {
    id: '',
    image: '',
    position: '',
    author: '',
    content: '',
    rating: 0
  };
  editMode = false;
  selectedFile?: File;
  showSpinner = true;

  constructor(
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private firestoreService: FirestoreService
  ) {}

  ngOnInit(): void {
    this.getAllTestimonials();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  getAllTestimonials() {
    this.firestoreService.getAll('testimonials').subscribe({
      next: (data) => {
        this.testimonials = data;
        this.showSpinner = false;
      },
      error: (error) => {
        this.showSpinner = false;
        this.sharedService.handleError(error, undefined, "Fehler beim Laden der Erfahrungsberichte.");
      }
    });
  }

  saveTestimonial(form: NgForm) {
    this.spinner.show();
    if (form.invalid) {
      this.spinner.hide();
      return;
    }

    const saveOrUpdate = () => {
      if (this.editMode && this.currentTestimonial.id) {
        // Update testimonial
        this.firestoreService.update('testimonials', this.currentTestimonial.id, this.currentTestimonial).subscribe({
          next: () => {
            this.spinner.hide();
            this.resetForm();
            this.getAllTestimonials();
            this.sharedService.handleSuccess("Erfahrungsbericht erfolgreich aktualisiert");
          },
          error: (err) => {
            this.spinner.hide();
            this.sharedService.handleError(err, undefined, "Fehler beim Aktualisieren des Erfahrungsberichts.");
          }
        });
      } else {
        // Add new testimonial
        this.firestoreService.add('testimonials', this.currentTestimonial).subscribe({
          next: () => {
            this.spinner.hide();
            this.resetForm();
            this.getAllTestimonials();
            this.sharedService.handleSuccess("Erfahrungsbericht erfolgreich hinzugefügt");
          },
          error: (err) => {
            this.spinner.hide();
            this.sharedService.handleError(err, undefined, "Fehler beim Hinzufügen des Erfahrungsberichts.");
          }
        });
      }
    };

    // If a file is selected, upload it first and get the URL
    if (this.selectedFile) {
      const filePath = `testimonial-images/${Date.now()}_${this.selectedFile.name}`;
      this.firestoreService.uploadFile(filePath, this.selectedFile).subscribe({
        next: (url) => {
          this.currentTestimonial.image = url;
          saveOrUpdate();
        },
        error: (error) => {
          this.spinner.hide();
          this.sharedService.handleError(error, undefined, "Fehler beim Hochladen des Bildes.");
        }
      });
    } else {
      saveOrUpdate();
    }
  }

  editTestimonial(testimonial: Testimonial) {
    this.currentTestimonial = { ...testimonial };
    this.editMode = true;
    this.selectedFile = undefined;
    const modal = new (window as any).bootstrap.Modal(document.getElementById('testimonialModal'));
    modal.show();
  }

  deleteTestimonial(id: string) {
    Swal.fire({
      title: 'Sind Sie sicher?',
      text: 'Diese Aktion löscht den Erfahrungsbericht dauerhaft.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ja, löschen!',
      cancelButtonText: 'Abbrechen'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.firestoreService.delete('testimonials', id).subscribe({
          next: () => {
            this.spinner.hide();
            this.getAllTestimonials();
            Swal.fire('Gelöscht!', 'Der Erfahrungsbericht wurde gelöscht.', 'success');
          },
          error: (err) => {
            this.spinner.hide();
            this.sharedService.handleError(err, undefined, "Fehler beim Löschen des Erfahrungsberichts.");
          }
        });
      }
    });
  }

  resetForm() {
    this.currentTestimonial = { id: '', image: '', position: '', author: '', content: '', rating: 0 };
    this.editMode = false;
    this.selectedFile = undefined;
  }

  private closeModal() {
    const modalEl = document.getElementById('testimonialModal');
    if (modalEl) {
      const modalInstance = (window as any).bootstrap.Modal.getInstance(modalEl);
      modalInstance?.hide();
    }
  }
}